import { ref } from "vue";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";
import { logException } from "@sazka/utils/logger/use-app-logger";
import { mountComponent } from "@sazka/utils/mount-helper";

const isMounted = ref(false);
const mountPromise = ref<Promise<any> | null>(null);

/**
 * Hook to mount the authentication component with optional loader handling.
 * @param useLoader - Whether to show the DS overlay loader during the mounting process.
 */
export const useMountAuthentication = async (useLoader = true): Promise<void> => {
    if (isMounted.value || mountPromise.value) return mountPromise.value;

    try {
        const importFn = () => import("../user-authentication.vue");

        if (useLoader) Loader.show();
        mountPromise.value = mountComponent("auth", importFn);
        await mountPromise.value;

        isMounted.value = true;
    } catch (e) {
        eventBus.emit(GlobalEvents.WebLoginAborted);

        logException("Authentication error", {
            errorMessage: "Failed to mount authentication component",
            error: e,
        });
    } finally {
        if (useLoader) Loader.hide();
    }
};
